import { render, staticRenderFns } from "./TotalPointsScreen.vue?vue&type=template&id=df12a2d2"
import script from "./TotalPointsScreen.vue?vue&type=script&lang=js"
export * from "./TotalPointsScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports